<template>
  <div>
    <Tabs type="card">
      <TabPane label="合作保险公司信息披露">
        <Table :columns="columns2" :data="data2"></Table
      ></TabPane>
      <TabPane label="客户告知书">
        <img src="./../images/《客户告知书》20260319-图片-0.jpg" alt="" style="width: 100%;" />
        <img src="./../images/《客户告知书》20260319-图片-1.jpg" alt="" style="width: 100%;" />
        <div v-show="false">
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: center;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 16pt; font-weight: bold"
              >客户告知书</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt"
              >尊敬的客户：</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt"
              >感谢您委托我公司为您办理业务。本公司是基于投保人的利益，为投保人与保险人订立保险合同提供直接服务，并依法向保险公司收取经纪费的保险专业中介机构。为了保护您的合法权益，按照《保险经纪机构监管规定》，本公司应履行客户告知义务，现将有关事项告知如下，请仔细阅读：</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >一、</span
            ><span style="font: 7pt 'Times New Roman'"> </span
            ><span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >公司基本情况：</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Wingdings; font-size: 10.5pt"></span
            ><span style="font: 7pt 'Times New Roman'">&nbsp; </span
            ><span style="font-family: 宋体; font-size: 10.5pt">名称：</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >上海妙保保险经纪股份有限公司</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Wingdings; font-size: 10.5pt"></span
            ><span style="font: 7pt 'Times New Roman'">&nbsp; </span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >营业场所：上海市浦东新区浦东大道</span
            ><span style="font-family: Calibri; font-size: 10.5pt">138</span
            ><span style="font-family: 宋体; font-size: 10.5pt">号永华大厦</span
            ><span style="font-family: Calibri; font-size: 10.5pt">8F</span>
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Wingdings; font-size: 10.5pt"></span
            ><span style="font: 7pt 'Times New Roman'">&nbsp; </span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >许可证名称及编号：经营保险经纪业务许可证&nbsp;&nbsp; 编</span
            ><span style="font-family: 宋体; font-size: 10.5pt">号</span
            ><span style="font-family: 宋体; font-size: 10.5pt">：</span
            ><span style="font-family: Calibri; font-size: 10.5pt"
              >260860320103800</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Wingdings; font-size: 10.5pt"></span
            ><span style="font: 7pt 'Times New Roman'">&nbsp; </span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >组织机构代码证、营业执照代码：</span
            ><span style="font-family: Calibri; font-size: 10.5pt"
              >913100005587636058</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Wingdings; font-size: 10.5pt"></span
            ><span style="font: 7pt 'Times New Roman'">&nbsp; </span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >业务范围：在全国区域内（港、澳、台除外）为投保人拟定投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或者风险评估、风险管理咨询服务；中国银保监会批准的其他业务。（依法须经批准的项目，经相关部门批准后方可开展经营活动）</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Wingdings; font-size: 10.5pt"></span
            ><span style="font: 7pt 'Times New Roman'">&nbsp; </span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >经营区域：全国</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Wingdings; font-size: 10.5pt"></span
            ><span style="font: 7pt 'Times New Roman'">&nbsp; </span
            ><span style="font-family: 宋体; font-size: 10.5pt">联系方式：</span
            ><span style="font-family: Calibri; font-size: 10.5pt">400</span
            ><span style="font-family: Calibri; font-size: 10.5pt"
              >8335060</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >二、</span
            ><span style="font: 7pt 'Times New Roman'"> </span
            ><span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >分公司基本情况：</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（</span
            ><span style="font-family: Calibri; font-size: 10.5pt">1</span
            ><span style="font-family: 宋体; font-size: 10.5pt">）</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >上海妙保保险经纪股份有限公司北京分公司</span
            >
          </p>
          <p
            style="
              margin: 0pt 0pt 0pt 21pt;
              orphans: 0;
              text-align: justify;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt"
              >营业场所：北京市朝阳区霄云路</span
            ><span style="font-family: Calibri; font-size: 10.5pt">40</span
            ><span style="font-family: 宋体; font-size: 10.5pt">号院</span
            ><span style="font-family: Calibri; font-size: 10.5pt">1</span
            ><span style="font-family: 宋体; font-size: 10.5pt">号楼</span
            ><span style="font-family: Calibri; font-size: 10.5pt">5</span
            ><span style="font-family: 宋体; font-size: 10.5pt">层</span
            ><span style="font-family: Calibri; font-size: 10.5pt">05-107</span
            ><span style="font-family: Calibri; font-size: 10.5pt"> </span>
          </p>
          <p
            style="
              margin: 0pt 0pt 0pt 21pt;
              orphans: 0;
              text-align: justify;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">电话：</span
            ><span style="font-family: Calibri; font-size: 10.5pt"
              >010-57091415</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（</span
            ><span style="font-family: Calibri; font-size: 10.5pt">2</span
            ><span style="font-family: 宋体; font-size: 10.5pt">）</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >上海妙保保险经纪股份有限公司山西分公司</span
            >
          </p>
          <p
            style="
              margin: 0pt 0pt 0pt 21pt;
              orphans: 0;
              text-align: justify;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">营业场所：</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >山西省太原市小店区晋阳街</span
            ><span style="font-family: Calibri; font-size: 10.5pt">18</span
            ><span style="font-family: 宋体; font-size: 10.5pt">号东悦广场</span
            ><span style="font-family: Calibri; font-size: 10.5pt">4</span
            ><span style="font-family: 宋体; font-size: 10.5pt">号楼</span
            ><span style="font-family: Calibri; font-size: 10.5pt">1703 </span>
          </p>
          <p
            style="
              margin: 0pt 0pt 0pt 21pt;
              orphans: 0;
              text-align: justify;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">电话：</span
            ><span style="font-family: Calibri; font-size: 10.5pt"
              >15513525557</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（</span
            ><span style="font-family: Calibri; font-size: 10.5pt">3</span
            ><span style="font-family: 宋体; font-size: 10.5pt">）</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >上海妙保保险经纪股份有限公司江苏分公司</span
            >
          </p>
          <p
            style="
              margin: 0pt 0pt 0pt 21pt;
              orphans: 0;
              text-align: justify;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">营业场所：</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >南京市秦淮区汉中路</span
            ><span style="font-family: Calibri; font-size: 10.5pt">1</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >号国际金融中心</span
            ><span style="font-family: Calibri; font-size: 10.5pt">29</span
            ><span style="font-family: 宋体; font-size: 10.5pt">楼 </span>
          </p>
          <p
            style="
              margin: 0pt 0pt 0pt 21pt;
              orphans: 0;
              text-align: justify;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">电话：</span
            ><span style="font-family: Calibri; font-size: 10.5pt"
              >025-52251812</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（</span
            ><span style="font-family: Calibri; font-size: 10.5pt">4</span
            ><span style="font-family: 宋体; font-size: 10.5pt">）</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >上海妙保保险经纪股份有限公司苏州分公司</span
            >
          </p>
          <p
            style="
              margin: 0pt 0pt 0pt 21pt;
              orphans: 0;
              text-align: justify;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">营业场所：</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >江苏省苏州市常熟市环城南路</span
            ><span style="font-family: Calibri; font-size: 10.5pt">17</span
            ><span style="font-family: 宋体; font-size: 10.5pt">号 </span>
          </p>
          <p
            style="
              margin: 0pt 0pt 0pt 21pt;
              orphans: 0;
              text-align: justify;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">电话：</span
            ><span style="font-family: Calibri; font-size: 10.5pt"
              >0512-52880001</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（</span
            ><span style="font-family: Calibri; font-size: 10.5pt">5</span
            ><span style="font-family: 宋体; font-size: 10.5pt">）</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >上海妙保保险经纪股份有限公司</span
            ><span style="font-family: 宋体; font-size: 10.5pt">四川</span
            ><span style="font-family: 宋体; font-size: 10.5pt">分公司</span>
          </p>
          <p
            style="
              margin: 0pt 0pt 0pt 21pt;
              orphans: 0;
              text-align: justify;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">营业场所：</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >成都市武侯区人民南路四段</span
            ><span style="font-family: Calibri; font-size: 10.5pt">19</span
            ><span style="font-family: 宋体; font-size: 10.5pt">号</span
            ><span style="font-family: Calibri; font-size: 10.5pt">1</span
            ><span style="font-family: 宋体; font-size: 10.5pt">幢</span
            ><span style="font-family: Calibri; font-size: 10.5pt">12</span
            ><span style="font-family: 宋体; font-size: 10.5pt">楼</span
            ><span style="font-family: Calibri; font-size: 10.5pt">3</span
            ><span style="font-family: 宋体; font-size: 10.5pt">号</span
            ><span style="font-family: Calibri; font-size: 10.5pt">4</span
            ><span style="font-family: 宋体; font-size: 10.5pt">号</span>
          </p>
          <p
            style="
              margin: 0pt 0pt 0pt 21pt;
              orphans: 0;
              text-align: justify;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">电话：</span
            ><span style="font-family: Calibri; font-size: 10.5pt"
              >028-85570128</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >三、</span
            ><span style="font: 7pt 'Times New Roman'"> </span
            ><span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >服务范围：</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（一）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >经纪服务关系的建立：接受客户委托，向客户出示《客户告知书》，并签订书面委托协议；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（二）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >专业风险评估：应用专业技术对服务项目进行风险识别、风险估测、风险评价；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（三）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >拟定投保方案：在风险管理基础上，以标的获得最充分保障为目的，为客户量身拟定投保方案；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（四）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >询价及报价分析：向多家保险公司进行询价，并对相关承保保险公司的资质、服务质量、报价等进行汇总。向客户出具报价书，为客户提供专业指导意见，推荐合适的承保公司；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（五）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >办理投保手续：为客户办理投保手续；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（六）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >保险期内日常服务：定期回访客户，向客户了解保险标的的状况；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（七）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >协助索赔：协助客户查勘，帮助客户做好索赔资料准备工作，以专业知识和技能协助客户解决索赔的疑难问题；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >四、 </span
            ><span style="font: 7pt 'Times New Roman'"></span>
            <span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >投保提示：</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（一）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >请仔细阅读保险条款，保险产品的广告、公告、彩页等宣传资料不属于保险合同的组成部分。并可要求本公司业务人员对以下重点内容进行详细讲解：</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Calibri; font-size: 10.5pt">1</span
            ><span style="font-family: 宋体; font-size: 10.5pt">、</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >投保的保险公司、投保险种的名称、投保条件、保险期限和缴纳的保险费；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Calibri; font-size: 10.5pt">2</span
            ><span style="font-family: 宋体; font-size: 10.5pt">、</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >被保险人的义务；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Calibri; font-size: 10.5pt">3</span
            ><span style="font-family: 宋体; font-size: 10.5pt">、</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >保险责任；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Calibri; font-size: 10.5pt">4</span
            ><span style="font-family: 宋体; font-size: 10.5pt">、</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >除外责任，免赔额或免赔率；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Calibri; font-size: 10.5pt">5</span
            ><span style="font-family: 宋体; font-size: 10.5pt">、</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >犹豫期后解除合同损失、等待期等内容；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（二）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >请向本公司业务人员了解《中华人民共和国保险法》等法律法规对于索赔失效、保险公司理赔时限、合同中止与失效、未成年人投保限额等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄不真实等情形导致的法律后果；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >五、</span
            ><span style="font: 7pt 'Times New Roman'"> </span
            ><span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >法律责任</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（一）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >保险经纪人作为被保险人的代表，独立承担法律责任。根据《中华人民共和国保险法》的规定，保险经纪人应对投保人或被保险人负责，有义务利用自己的知识和技能为其委托人购买最佳的保险。如果因为保险经纪人的疏忽致使被保险人利益受到损害的，保险经纪人依法承担赔偿责任</span
            ><span style="font-family: 宋体; font-size: 10.5pt">；</span>
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（二）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >有关于保险标的相关事宜，投保人或保险人有义务向公司业务员如实告知，必要时需出具告知或保证等相关书面材料，如因不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄不真实等情形导致的法律后果由投保人或被保险人承担；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（三）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt">本公司已</span
            ><span style="font-family: 宋体; font-size: 10.5pt">按</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >《保险经纪机构监管规定》投保职业责任保险；</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">（四）</span
            ><span style="font: 7pt 'Times New Roman'"></span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >根据保险监管部门的规定，只有持《保险经纪从业人员职业资格证书》的人员方可从事保险经纪业务，您可要求本公司业务人员出示《保险经纪从业人员职业资格证书》，并可通过登录中国保监会保险中介监管信息系统查询业务人员持证情况。</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >六、</span
            ><span style="font: 7pt 'Times New Roman'"> </span
            ><span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >服务手续费收取标准</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt"
              >本公司财务单边收费制度，依法向保险公司收取经纪费。</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >七、</span
            ><span style="font: 7pt 'Times New Roman'"> </span
            ><span
              style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
              >投诉服务</span
            >
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt"
              >如果您发现本公司从业人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证据或其他证据，可向本公司投诉（电话：</span
            ><span style="font-family: Calibri; font-size: 10.5pt">400</span
            ><span style="font-family: Calibri; font-size: 10.5pt">8335060</span
            ><span style="font-family: 宋体; font-size: 10.5pt">）。</span>
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt">我声明</span
            ><span style="font-family: Calibri; font-size: 10.5pt">:</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >上海妙保保险经纪股份有限公司</span
            ><span style="font-family: 宋体; font-size: 10.5pt">的服务人员</span
            ><span style="font-family: 宋体; font-size: 10.5pt"
              >已经对我投保相关的事项讲解清楚，我也对上述内容明确理解。</span
            ><span style="font-family: 宋体; font-size: 10.5pt"> </span>
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Calibri; font-size: 10.5pt">&nbsp;</span>
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Calibri; font-size: 10.5pt">&nbsp;</span>
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Calibri; font-size: 10.5pt">&nbsp;</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
            <span style="font-family: Calibri; font-size: 10.5pt">&nbsp;</span>
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: Calibri; font-size: 10.5pt">&nbsp;</span>
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: right;

              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 10.5pt"
              >上海妙保保险经纪股份有限公司</span
            >
          </p>
        </div>
      </TabPane>
      <!-- <TabPane label="互联网保险产品">
        <Table :columns="columns1" :data="data1"></Table>
      </TabPane> -->
      <TabPane label="中保协的验真途径">
        中国保险行业协会，互联网保险-中介类信息披露如下：
        <a
          href="http://icidp.iachina.cn/"
          target="blank"
          style="font-size: 16px;"
          >http://icidp.iachina.cn/</a
        >
      </TabPane>
      <TabPane label="省级分公司的联系方式">
        （一）上海妙保保险经纪股份有限公司北京分公司 <br />
        营业场所：北京市朝阳区东四环中路82号3座18层2102
        <br />电话：18667039966<br />
        <br />（二）上海妙保保险经纪股份有限公司山西分公司<br />
        营业场所：山西省太原市小店区亲贤北街79号72幢茂业中心18层04单元<br />
        电话：18984128393
        <br /><br />（三）上海妙保保险经纪股份有限公司江苏分公司<br />
        营业场所：南京市江宁区东山街道绿都大道31号906室
        <br />电话：13918616455<br />
        <br />（四）上海妙保保险经纪股份有限公司苏州分公司<br />
        营业场所：常熟市海虞南路1号江南大厦1幢1703 <br />电话：15176186123<br />
        <br />（五）上海妙保保险经纪股份有限公司四川分公司<br />
        营业场所：中国（四川）自由贸易试验区成都高新区天仁路388号1栋4单元9层901号附2号（自编号）
        <br />电话：15215175554<br />
        <br />（六）上海妙保保险经纪股份有限公司河北分公司<br />
        营业场所：河北省邢台经济开发区中兴东大街1889号河北工业大学科技园3号楼12层1219室<br />
        <br />电话：15825280635<br />
      </TabPane>
      <TabPane label="理赔投诉渠道">
        <img
          style="width: 70%;display: block;margin: auto;"
          src="./../images/tslp.png"
        />
        投诉办理须知<br />
        1.投诉人为申请资格人或其委托人。申请资格人致电投诉时，需提供本人姓名和手机号以便我司核实保单信息。如投诉涉及服务或流程政策类，需提供客户注册的会员名、服务顾问等信息。我们会对您提供的信息严格保密。
        <br />2.您的投诉问题登记后，我们将指派专员与您取得联系，后续会定期向您反馈案件处理进展。对于事实清楚、争议情况简单的消费投诉，自收到消费投诉之日起15日内作出处理决定并告知投诉人，情况复杂的延长至30日；情况特别复杂或者有其他特殊原因的，经公司品质管理部负责人审批并告知投诉人，再延长30日。
        <br /><br />投诉电话 <br />全国统一投诉电话：010-57091415
        <br />服务时间：9：00——17:00（周一至周五）
      </TabPane>
      <TabPane label="消费者权益保障">
        法律声明与隐私政策<br /><br />

        本版发布日期：2021年8月23日<br /><br />

        生效日期：2021年8月23日<br /><br />

        一、法律声明<br /><br />

        在使用"妙保"微信公众号以及微信小程序的所有产品和服务前，请您务必仔细阅读并理解以下条款。一旦您选择使用"妙保"微信公众号以及微信小程序，即表示您认可并接受本条款内容及可能随时更新的内容。<br /><br />

        <br /><br />

        一般原则<br /><br />

        以下规则适用于所有"妙保"微信公众号以及微信小程序用户和浏览者，"妙保"微信公众号以及微信小程序可能随时修改这些条款。因为这些条款与您密切相关，您应经常访问本页面以了解当前的条款。这些条款的内容也可能被"妙保"微信公众号以及微信小程序页面上或其他特定服务所发布的法律通告而取代，您应该了解这些内容。一旦您接受本条款，即意味着您已经详细阅读并接受了前述这些被引用或取代的条款。<br /><br />

        权利说明<br /><br />

        上海妙保保险经纪股份有限公司及其关联公司以下合称（“妙保经纪”）对其所发行的或与合作公司所共同发行的，包括但不限于"妙保经纪"所经营微信公众号以及微信小程序及相关产品或服务的全部内容，享有知识产权并受法律保护。如果"妙保经纪"未对前述内容作权利声明，并不代表"妙保经纪"对其不享有权利或不主张权利。您应根据法律、法规及诚实信用原则，尊重权利人的合法权益并合法使用该内容。<br /><br />
        未经妙保经纪书面许可，任何单位及个人不得以任何方式或理由对上述软件、产品、服务、信息和文字的任何部分进行使用、复制、修改、抄录、传播或与其他产品捆绑使用、销售或以超级链路连接或传送存储于信息检索系统或其他任何商业目的的使用，但对于非商业目的的、个人使用的下载或打印除外。<br /><br />
        "妙保"微信公众号以及微信小程序中使用和显示的商标和标识（以下简称“商标”）是妙保经纪及其关联公司或合作公司注册和未注册的有关商标，受法律保护，未经允许，您不得擅自使用。"妙保"微信公众号以及微信小程序中所载的任何内容未经妙保经纪书面许可，任何人不得以任何方式使用。<br /><br />

        用户信息
        <br /><br />您在注册成为"妙保"微信公众号以及微信小程序的用户、使用"妙保"微信公众号以及微信小程序的产品和服务时，代表您在知情和同意的情况下，自愿向"妙保"微信公众号以及微信小程序提供您的个人信息，例如姓名、证件类型、证件号码、证件有效期限、手机号、邮箱、联系地址、第三方支付账户等（以下简称“个人信息”）。
        <br /><br />在必要情形下第三方可能接触并使用您的个人信息，包括得到授权的"妙保"微信公众号以及微信小程序员工，以及执行与我们的业务、营销活动和数据整理有关工作的其他公司或人员。所有此类人员及公司均需遵守相关保密协议，同时也需遵守国家关于个人信息保护有关法律法规，以确保您的个人信息随时得到保护。
        <br /><br />除上述用途外，"妙保"微信公众号以及微信小程序不会将您的个人信息用于任何未经您同意的用途。也不会将所接受的您的任何个人信息泄露、篡改或毁损。
        <br /><br />您可阅读下面的"妙保"微信公众号以及微信小程序隐私政策以了解更加详细的内容。
        责任限制<br /><br />

        不论在何种情况下，"妙保"微信公众号以及微信小程序对由于信息网络维护、信息网络连接故障、智能终端、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、火灾、洪水、风暴、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。<br /><br />
        无论在任何情况下，由于使用"妙保"微信公众号以及微信小程序上的信息或由"妙保"微信公众号以及微信小程序链接的信息，或其他与"妙保"微信公众号以及微信小程序链接的网站信息，对您或他人造成的任何损失或损害（包括直接、间接损失或损害，例如收益或利益之损失，智能终端系统之损坏或数据丢失等后果），均由使用者自行承担责任（包括但不限于疏忽责任）。<br /><br />
        "妙保"微信公众号以及微信小程序所载的信息包括但不限于文本、图片、数据、观点、网页或链接，虽然力图准确或详尽，但"妙保"微信公众号以及微信小程序并不就其所包含的信息和内容的准确、完整、充分和可靠性做任何承诺。"妙保"微信公众号以及微信小程序表明不对这些信息和内容的错误或遗漏承担责任，也不对这些信息和内容做出任何明示或默示的、包括但不限于没有侵犯第三方权利、质量和没有智能终端病毒的保证。<br /><br />

        第三方链接<br /><br />

        "妙保"微信公众号以及微信小程序可能保留有第三方网站或网址的链接，访问这些链接将由用户自己做出决定，"妙保"微信公众号以及微信小程序并不就这些连接上所提供的任何信息、数据、观点、图片陈述或建议的准确性、完整性、充分性和可靠性提供承诺或保证。"妙保"微信公众号以及微信小程序没有审查过任何第三方网站，对这些网站及其内容不进行控制，也不负任何责任。如果您决定访问任何与本站链接的第三方网站，其可能带来的结果和风险全部由您自己承担。<br /><br />

        适用法律和管辖权<br /><br />

        通过访问"妙保"微信公众号以及微信小程序软件平台或使用"妙保"微信公众号以及微信小程序提供的服务，即表示您同意该访问或服务受中华人民共和国法律的约束，且您同意受中华人民共和国司法的管辖。访问或接受服务过程中，发生的争议应当争取协商解决，协商不成的，各方一致同意至妙保经纪住所所在地有管辖权的法院诉讼解决。<br /><br />

        二、隐私政策<br /><br />
        对于本政策中与您的权益存在重大关系的条款和个人敏感信息，采用粗体字进行标注以提示您注意。<br /><br />

        1、为了向您提供服务所需，我们会按照合法、正当、必要的原则收集您的信息。<br /><br />
        2、如果为了向您提供服务而需要将您的信息共享至第三方，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施并且严格遵守相关法律法规与监管要求。另外，我们会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意或确认第三方已经征得您的同意。<br /><br />
        3、如果为了向您提供服务而需要从第三方获取您的信息，我们将要求第三方说明信息来源，并要求第三方保障其提供信息的合法性；如果我们开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权范围，我们将征得您的明确同意。<br /><br />

        上海妙保保险经纪有限公司和妙保经纪及其关联公司（办公地址：上海市浦东新区浦东大道138号永华大厦8F  ；联系方式：400-103-1660；以下合称“我们”）尊重并保护您的隐私。您使用我们的服务时，我们将按照本隐私政策（以下简称“本政策”）收集、存储、使用及对外提供您的信息。同时，我们会通过本政策向您说明，我们如何为您提供访问、更新、管理和保护您的信息的服务。本政策与您使用我们的服务关系紧密，我们建议您仔细阅读并理解本政策全部内容，做出您认为适当的选择。我们努力用通俗易懂、简明扼要的文字表达，并对本政策中与您的权益存在重大关系的条款和个人敏感信息，采用粗体字进行标注以提示您注意。<br /><br />

        为了遵守国家法律法规及监管规定（例如：进行实名制管理、履行反洗钱职责、安全管理），也为了向您提供服务及提升服务质量，我们需要收集、存储、使用及对外提供您的信息。您同意我们按照本政策约定处理您的信息，以便您享受优质、便捷、个性化的服务，同时更好地保护您的账户及资金安全。<br /><br />

        我们收集以下信息<br /><br />

        在您使用"妙保"微信公众号以及微信小程序各项业务功能（以下简称“服务”）的过程中，我们需要收集您的一些信息，用以向您提供服务、提升我们的服务质量、保障您的账户和资金安全以及符合国家法律法规及监管规定，<br /><br />

        （一）您在使用我们服务时主动提供的信息<br /><br />

        1、账户注册<br /><br />

        在您注册"妙保"微信公众号以及微信小程序账户或使用"妙保"微信公众号以及微信小程序服务时，您需提供昵称、头像、手机号码或者电子邮箱作为账户登录名。如您不提供前述信息，可能无法注册"妙保"微信公众号以及微信小程序账户或无法使用"妙保"微信公众号以及微信小程序服务。<br /><br />

        2、实名认证<br /><br />

        我们需根据相关法律法规及监管要求，您需要提供姓名、证件类型、证件号码、证件有效期。提示您适时提供有效身份证件的彩色影印件或照片以供我们核对并留存；如您不提供前述彩色影印件、照片或不同意我们留存，可能无法使用与监管要求相关的部分服务，但不影响您使用我们提供的其他服务。<br /><br />

        3、快捷支付及提现<br /><br />
        为了您能使用快捷支付服务，购买产品，您需提供您的开户行名称、银行卡卡号、银行卡有效期、姓名、身份证号码、银行预留手机号。我们会将前述信息与通过第三方支付公司进行验证。在您使用快捷支付服务时，我们需要记录您的交易信息。如您不提供前述信息，可能无法使用快捷支付服务，但不影响您使用我们提供的其他服务。<br /><br />

        4、重要操作行为验证<br /><br />
        为了保障您的账户和资金安全，在您进行一些重要的账户操作时（例如：找回密码、挂失账户、冻结交易资金等），我们需要验证您的身份，为此您可能需向我们提供身份证件影印件、手持身份证照片、交易凭证及其他在具体业务开展过程中基于您的同意而收集的可识别您身份的证明资料；如您不同意提供前述信息，您将无法完成特定操作，但不影响您使用我们提供的其他服务。<br /><br />

        （二）我们在您使用服务时获取的信息<br /><br />

        1、日志信息<br /><br />

        当您使用我们的服务时，我们可能会自动收集相关信息并存储为服务日志信息。<br /><br />

        （1）设备信息，包括设备型号、操作系统版本、唯一设备标识符、电池、信号强度等信息。<br /><br />

        （2）软件信息，包括软件的版本号、浏览器类型。为确保操作环境的安全或提供服务所需，我们会收集有关您使用的移动应用和其他软件的信息。<br /><br />

        （3）IP地址<br /><br />

        （4）服务日志信息，包括您在使用我们服务时搜索、查看的信息、服务故障信息、引荐网址等信息。<br /><br />

        2、位置信息<br /><br />

        （1）当您使用与位置有关的服务时，我们可能会记录您设备所在的位置信息，以便为您提供相关服务，我们可能会通过IP地址
        、GPS、WLAN（如 WiFi)或基站等途径获取您的地理位置信息；<br /><br />

        （2）出于风险控制目的，我们会收集您的设备Mac地址信息。<br /><br />

        3、其他相关信息<br /><br />

        为了帮助您更好地使用我们的产品或服务，我们会收集相关信息。为确保您使用我们服务时能与您认识的人进行联系，如您选择开启导入通讯录功能，我们可能对您联系人的姓名和电话号码进行加密，并仅收集加密后的信息。为精准运营为您提供更便捷、更个性化的服务，我们会收集您的软件安装列表信息。<br /><br />

        请您理解，我们向您提供的服务是不断更新和发展的，基于该服务我们需要收集您的信息的，我们会通过页面提示、交互流程、协议约定的方式另行向您说明信息收集的范围与目的，并征得您的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息，您可能无法使用某项或某部分服务，但不影响您使用我们提供的其他服务。此外，第三方主体可能会通过"妙保"微信公众号以及微信小程序向您提供服务。当您进入第三方主体运营的服务页面时，请注意相关服务由第三方主体向您提供。涉及到第三方主体向您收集个人信息的，建议您仔细查看第三方主体的隐私政策或协议约定。<br /><br />

        我们如何使用信息<br /><br />

        <br /><br />
        我们要将信息用于本政策未载明的其他用途时，会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认动作等形式再次征得您的同意。<br /><br />

        我们会采取脱敏、去标识化等方式对您的信息进行综合统计、分析加工，以便为您提供更加准确、个性、流畅及便捷的服务，或帮助我们评估、改善或设计服务及运营活动；<br /><br />

        为了提升用户服务体验，为用户推荐更为优质或适合的服务，我们可能会根据用户信息形成群体特征标签，用于向用户提供其可能感兴趣的营销活动通知、商业性电子信息或广告，如您不希望接收此类信息，您可按照我们提示的方法选择退订。<br /><br />

        原则上我们不会将您的信息进行公开披露。如确需公开披露时，我们会向您告知公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明确同意。但是根据相关法律法规及国家标准，在以下情形中，我们可能会依法共享、披露您的个人信息无需征得您的同意：<br /><br />
        （1）与国家安全、国防安全直接相关的；<br /><br />
        （2）与公共安全、公共卫生、重大公共利益直接相关的；<br /><br />
        （3）与犯罪侦查、起诉、审判和判决执行等直接相关的；<br /><br />
        （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；<br /><br />

        （5）根据法律法规或监管要求向相关部门进行报告；<br /><br />

        （6）法律法规规定或其他有权机关强制性要求的其他情形。<br /><br />

        我们如何使用Cookie：<br /><br />

        为使您获得更轻松的访问体验，您访问"妙保"微信公众号以及微信小程序网站或使用"妙保"微信公众号以及微信小程序提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做可帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全状态。这些数据文件可能是Cookie，Flash
        Cookie，您的浏览器或关联应用程序提供的其他本地存储（以下简称“Cookie”）。请您理解，我们的某些服务只能通过使用Cookie才可得到实现。如您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝"妙保"微信公众号以及微信小程序的Cookie。多数浏览器工具条中的“帮助”部分会告诉您怎样防止您的浏览器接受新的Cookie，怎样让您的浏览器在您收到一条新Cookie时通知您或者怎样彻底关闭Cookie。此外，您可以通过改变浏览器附加程序的设置，或通过访问提供商的网页，来关闭或删除浏览器附加程序使用的Flash
        Cookie及类似数据。但这一举动在某些情况下可能会影响您安全访问"妙保"微信公众号以及微信小程序网站和使用"妙保"微信公众号以及微信小程序提供的服务。<br /><br />

        信息存储地点及期限<br /><br />

        我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如部分服务涉及跨境业务，我们需要向境外机构传输境内收集的相关个人信息的，我们会按照法律法规和相关监管部门的规定执行，并单独征得您的授权同意并要求接收方按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理这些个人信息。<br /><br />

        一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：
        <br /><br />
        为遵守适用的法律法规等有关规定；<br /><br />

        为遵守法院判决、裁定或其他法律程序的规定；<br /><br />

        为遵守相关政府机关或法定授权组织的要求；<br /><br />

        我们有理由确信需要遵守法律法规等有关规定；<br /><br />

        为执行相关服务协议或本政策、维护社会公共利益，为保护们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。
        <br /><br />
        当我们的产品或服务发生停止运营的情形时，我们将采取包括但不限于推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。
        <br /><br />

        合作第三方软件开发包（以下简称SDK）如何收集、使用信息
        <br /><br />

        为保障"妙保"微信公众号以及微信小程序的稳定运行或实现相关功能，我们可能会接入由第三方提供的SDK来实现前述目的。我们接入的第三方SDK主要服务于您及其他用户的需求，因此在满足新的服务需求及业务功能变更时，我们可能会调整们接入的第三方SDK。我们会及时在本说明中向您公开明示接入的第三方SDK情况。目前"妙保"微信公众号以及微信小程序接入的第三方SDK列明如下：
        <br /><br />

        SDK名称收集信息业务场景SDK厂商信息友盟统计SDK运营商信息、设备标示符、设备相关应用信息及日志操作用于"妙保"微信公众号以及微信小程序安卓渠道包统计、埋点日志统计北京友盟网络科技有限公司小米推送SDK运营商信息、设备标示符用于"妙保"微信公众号以及微信小程序向小米手机用户推送消息北京小米科技有限责任公司个推推送SDK运营商信息、设备标示符用于"妙保"微信公众号以及微信小程序向非小米手机用户推送消息浙江每日互动网络科技股份有限公司支付宝SDK设备标识符、位置信息、运营商信息、Wi-Fi地址、应用列表可帮助用户完成付款、提供安全认证服务支付宝(中国)网络技术有限公司微信SDK运营商信息、设备标示符可帮助用户完成付款、分享到微信深圳市腾讯计算机系统有限公司百度地图SDK位置信息、设备信息、Wi-Fi地址帮助用户在发布信息时定位位置北京百度网讯科技有限公司实名认证SDK运营商信息、设备标示符帮助用户进行实名认证阿里云计算有限公司一键登录SDK运营商信息、设备信息帮助用户完成一键登录功能阿里云计算有限公司Firebase
        Crashlytics SDK
        设备标识符、错误日志信息监控线上Crash情况谷歌信息技术（中国）有限公司<br /><br />

        我们如何进行个人信息保护<br /><br />

        我们建立了相关内控制度，对可能接触到您的信息的工作人员采取最小够用授权原则；另外，我们的相应网络/系统通过了国家网络安全等级保护的测评。我们每年还会聘请外部独立第三方对我们的信息安全管理体系进行评估。<br /><br />

        为保障您的信息安全，我们致力于使用行业通行的各种安全技术及配套的管理体系来尽量降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。<br /><br />

        我们承诺对您的信息进行严格保密。除法律法规及监管部门另有规定外，我们仅在以下情形中与第三方共享您的信息，第三方包括我们的关联公司以及其他合作伙伴。如果为了向您提供服务而需要将您的信息共享至第三方，我们将要求第三方对您的信息采取保护措施，并且严格遵守相关法律法规与监管要求。另外，我们会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意，或确认第三方已经征得您的同意。<br /><br />
        （1）某些产品或服务可能由第三方提供或由我们与第三方共同提供，因此，只有共享您的信息，才能提供您需要的产品或服务；<br /><br />
        （2）如您选择参与我们和第三方联合开展的活动，我们可能与其共享活动过程中产生的、为完成活动所必要的信息，以便第三方能及时向您发放奖品或为您提供服务，我们会依据法律法规的要求，在活动规则页面或通过其他途径向您明确告知需要向第三方提供何种信息；<br /><br />
        （3）事先获得您明确同意的情况下，我们会在法律法规允许的范围内，依据您的授权范围与第三方共享您的信息。<br /><br />

        请您务必妥善保管好您的"妙保"微信公众号以及微信小程序登录名及其他身份要素。您在使用"妙保"微信公众号以及微信小程序服务时，我们会通过您的登录名及其他身份要素来识别您的身份。一旦您泄漏了前述信息，您可能会蒙受损失，并可能对您产生不利。如您发现"妙保"微信公众号以及微信小程序登录名及/或其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。<br /><br />

        如何管理您的个人信息<br /><br />

        您可通过登录"妙保"微信公众号以及微信小程序账户的方式，查阅您的身份信息、账单信息、账户信息以及绑定的银行卡等个人信息。<br /><br />
        如发现您的信息有误，您可以根据页面提示自助修改您的信息，您也可以联系我们的客服电话或通过在线客服要求更正。<br /><br />

        如您希望停止对您位置、存储等个人信息获取的授权，停止授权的操作路径为：手机设置>打开对应的应用管理>关闭对应权限。（注：不同操作系统的手机操作路径略有差异）<br /><br />

        您可以联系我们的客服电话或通过在线客服要求注销账户，当您符合账户注销条件并注销账户后，您该账户内的所有信息将被清空，我们将不会再收集、使用或对外提供与该账户相关的个人信息，但您在使用"妙保"微信公众号以及微信小程序服务期间提供或产生的信息我们仍需按照监管要求的时间进行保存，且在该保存的时间内依法配合有权机关的查询。<br /><br />

        如您发现我们收集、使用您个人信息的行为，违反了法律法规规定或违反了与您的约定，您可联系我们的客服热线或通过在线客服，要求删除相应的信息。<br /><br />

        为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的15天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。<br /><br />

        本政策的修订及更新
        <br /><br />

        发生下列重大变化情形时，我们会适时对本政策进行更新：<br /><br />
        （1）我们的基本情况发生变化，例如：兼并、收购、重组引起的所有者变更；<br /><br />
        （2）收集、存储、使用个人信息的范围、目的、规则发生变化；<br /><br />
        （3）对外提供个人信息的对象、范围、目的发生变化；<br /><br />
        （4）您访问和管理个人信息的方式发生变化；<br /><br />
        （5）数据安全能力、信息安全风险发生变化；<br /><br />
        （6）用户询问、投诉的渠道和机制，以及外部纠纷解决机构及联络方式发生变化；<br /><br />
        （7）其他可能对您的个人信息权益产生重大影响的变化。<br /><br />

        如本政策发生更新，我们将以推送通知、弹窗提示、发送邮件/短消息或者在"妙保"微信公众号以及微信小程序官方网站发布公告的方式来通知您。如您在本政策更新生效后继续使用"妙保"微信公众号以及微信小程序提供的服务，即表示您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。<br /><br />
      </TabPane>
      <!-- <TabPane label="自营网络平台">
        自营网络平台 网站https://www.miaoins.com/ <br />
        微信公众号：妙保（微信号miaobaoins）
      </TabPane> -->
      <TabPane label="资质证书">
        <img src="./../images/妙保营业执照-总部20260305-图片-0.jpg" style="width:100%" /><br /><img
          src="./../images/保险中介许可证0317.jpg"
          style="width:100%"
        />
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import { Tabs, TabPane, Table } from "view-design";
import { columns1, data1, columns2, data2 } from "./text";
export default {
  components: {
    Tabs,
    TabPane,
    Table
  },
  computed: {
    s() {
      return this.$style;
    }
  },
  data() {
    return {
      columns1,
      data1,
      columns2,
      data2
    };
  }
};
</script>

<style lang="less" module>
@import url("view-design/dist/styles/iview.css");
.tableizer_table {
  margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/components/PublicInfo.vue